import {
  api,
  CertificationTypeEnum,
  District,
  ExaminerDistrict,
  ExaminerDistrictAssignment,
  PagedResultOfExaminerDistrictHistoryRecord,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { getPaginationParameters, getQueryStringParameters } from 'utils';

type ExaminerDistrictListParams = TableState<never, { showHistorical: boolean }> & {
  examinerId: number;
  certificationType: CertificationTypeEnum;
};

export const districtsApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getExaminerDistrictList: builder.query<
      PagedResultOfExaminerDistrictHistoryRecord,
      ExaminerDistrictListParams
    >({
      query: (params) => {
        const input = getQueryStringParameters({
          ...getPaginationParameters(params),
          filter: {
            ...params.filters,
            examinerId: params.examinerId,
            certificationType: params.certificationType,
          },
        });
        return api.examinerDistrict.getExaminerDistrictList(input);
      },
      providesTags: ['DistrictAffiliation'],
    }),
    getAvailableDistrictOptions: builder.query<
      District[],
      { examinerId: number; certificationType: CertificationTypeEnum }
    >({
      query: (params) => api.examinerDistrict.getAvailableDistrictOptions(params),
      providesTags: ['DistrictAffiliation'],
    }),
    addDistrictAffiliation: builder.mutation<ExaminerDistrict, ExaminerDistrictAssignment>({
      query: (data) => api.examinerDistrict.addAffiliation(data),
      invalidatesTags: ['DistrictAffiliation', 'Examiner'],
    }),
    endDistrictAffiliation: builder.mutation<void, number>({
      query: (examinerDistrictId) => api.examinerDistrict.endAffiliation({ examinerDistrictId }),
      invalidatesTags: ['DistrictAffiliation', 'Examiner'],
    }),
  }),
});

export const {
  useGetExaminerDistrictListQuery,
  useGetAvailableDistrictOptionsQuery,
  useAddDistrictAffiliationMutation,
  useEndDistrictAffiliationMutation,
} = districtsApi;
